export const DEBUG = 0;
export const INFO = 1;
export const WARN = 2;
export const ERROR = 3;
export const FATAL = 4;
export const UNKNOWN = 5;
